<template>
  <div id="breadcrumbs">
    <ul id="ulBreadcrumbs" class="breadcrumb clearfix noprint">
      <li v-for="(breadcrumb, idx) in breadcrumbList" :key="idx">
        <dn-router-link v-if="idx !== breadcrumbList.length -1 && breadcrumb.link !== ''" :url="breadcrumb.link" :title="breadcrumbName(breadcrumb)" />
        
        <dn-router-link v-else-if="enabledFinalBreadcrumbs.includes(breadcrumb.name)" :url="breadcrumb.link" :title="breadcrumbName(breadcrumb)" />
        
        <span v-else-if="idx === breadcrumbList.length - 1 || breadcrumb.link === ''" class="disabled-breadcrumb"> {{ breadcrumb.name }}</span>

        <template v-if="idx !== breadcrumbList.length -1">
          /&nbsp;
        </template>

        <template v-if="areCategoryBreadcrumbsLoading === true && idx === breadcrumbList.length - 1">
          /&nbsp;...
        </template>
      </li>
    </ul>
  </div>
</template>
<script>
  import { mapGetters }         from "vuex"
  import { CatalogService }     from "@/services/CatalogService"
  import { DnRouterLink }       from "@/components/Elements"
  export default {
    name: "Breadcrumb",
    components: {
      DnRouterLink
    },
    data: () => ({
      breadcrumbList: [],
      areCategoryBreadcrumbsLoading: false,
      enabledFinalBreadcrumbs: ["News"]
    }),
    computed: {
      ...mapGetters(["user", "activeAccountId", "getContentItem","CurrentCategory", "audienceIds"]),
    },
    //when the route changes, update the local breadcrumblist to the list of the new page
    watch: {
      "$route" () { this.setDefaultBreadcrumbList() },
      "CurrentCategory" () {
        if(this.IsNotNullOrUndefined(this, "CurrentCategory") && this.$route.name === "CatalogListing"){
          this.addCategoryBreadcrumbs();
        }
      },
    },
    mounted () {      
      this.setDefaultBreadcrumbList();
    },
    methods: {
      breadcrumbName(breadcrumb) {
        if (breadcrumb.localizationKey) {
          return this.getContentItem(breadcrumb.localizationKey);
        } else {
          return breadcrumb.name;
        }
      },
      setDefaultBreadcrumbList: function () {
        this.breadcrumbList = this.$route.meta.breadcrumb
      },
      addCategoryBreadcrumbs: function () {
        this.areCategoryBreadcrumbsLoading = true;
        this.breadcrumbList = this.$route.meta.breadcrumb;
        var categoryBreadcrumbs = [];
        var currentCategoryBreadCrumb = {name: this.CurrentCategory.Title, link: `/catalog/catalogListing?currentCategoryId=${this.CurrentCategory.Id}`};
        categoryBreadcrumbs.push(currentCategoryBreadCrumb);
        if(this.CurrentCategory.ParentCategoryId == this.$store.state.tenant.costCenterRootCategoryId){
          this.breadcrumbList = this.breadcrumbList.concat(categoryBreadcrumbs);
          this.areCategoryBreadcrumbsLoading = false;
          return;
        }
        
        CatalogService.GetCategory(this.activeAccountId, this.user.UserId, this.CurrentCategory.ParentCategoryId, this.audienceIds).then(result => {
          var parentCategory = result.data
          var parentCategoryBreadcrumb = {name: parentCategory.Title, link: `/catalog/catalogListing?currentCategoryId=${parentCategory.Id}`};
          categoryBreadcrumbs.push(parentCategoryBreadcrumb);
        }).catch(err => {
          ErrorLogService.LogException(err);
        }).finally(() =>{            
          categoryBreadcrumbs = categoryBreadcrumbs.reverse();
          this.breadcrumbList = this.breadcrumbList.concat(categoryBreadcrumbs);
          this.areCategoryBreadcrumbsLoading = false;
        });
      },
    }
  }
</script>
<style>
.disabled-breadcrumb{
  color: gray;
}
</style>